// extracted by mini-css-extract-plugin
export default {"mainContainer":"Main_mainContainer__kXbkM","routes":"Main_routes__3zhQR"};